import React, { useEffect, useRef } from 'react';
import PopupModal from '../PopupModal';
import styles from './styles.module.scss';

interface ArchiveWrapperProps {
  year: string;
  url: string;
}

const ArchiveWrapper: React.FC<ArchiveWrapperProps> = ({ year, url }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 右クリック禁止
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // キーボードショートカット無効化（F12、Ctrl+Shift+I、Ctrl+Shift+J、Ctrl+U）
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I, Ctrl+Shift+J
      if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (ソースコード表示)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return false;
      }
    };

    // テキスト選択を無効化
    const handleSelectStart = (e: Event) => {
      e.preventDefault();
      return false;
    };

    // イベントリスナー登録
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);

    // iframe読み込み完了後の処理
    const handleIframeLoad = () => {
      try {
        // iframeのコンテンツにアクセスできない（クロスオリジン）ため、
        // オーバーレイで対策
        if (overlayRef.current) {
          overlayRef.current.style.display = 'none';
        }
      } catch {
        // クロスオリジンエラーは無視
      }
    };

    // iframeのrefを変数に保存（クリーンアップ関数用）
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
    }

    // コンソールメッセージ
    console.clear();
    console.log('%cかまた祭 ' + year, 'color: #3172f8; font-size: 24px; font-weight: bold;');
    console.log('%c© Kamata Festival. All rights reserved.', 'color: #666;');

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
      // 保存した変数を使用
      if (iframe) {
        iframe.removeEventListener('load', handleIframeLoad);
      }
    };
  }, [year]);

  // マウス位置追跡してステータスバーを隠す
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      // 画面下部に近づいたらカーソルを変更
      const threshold = window.innerHeight - 100;
      if (e.clientY > threshold) {
        document.body.style.cursor = 'default';
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className={styles.archive}>
      {/* ローディングオーバーレイ */}
      <div ref={overlayRef} className={styles.archive__loading}>
        <div className={styles.archive__loading__spinner}></div>
        <p>読み込み中...</p>
      </div>

      {/* 透明なオーバーレイ（URL表示を防ぐ） */}
      <div
        className={styles.archive__overlay}
        onMouseDown={() => {
          // iframe内のクリックをシミュレート
          if (iframeRef.current) {
            iframeRef.current.style.pointerEvents = 'auto';
            setTimeout(() => {
              if (iframeRef.current) {
                iframeRef.current.style.pointerEvents = 'none';
              }
            }, 100);
          }
        }}
      />

      <iframe
        ref={iframeRef}
        src={url}
        title={`かまた祭 ${year} アーカイブ`}
        className={styles.archive__iframe}
        style={{ border: 'none' }}
        // allow-popups-to-escape-sandbox: 新しいタブで開く PDF（タイムテーブル・MAP など）に sandbox を引き継がない。
        // 引き継ぐと Chrome が PDF の表示をブロックする
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
      />

      <PopupModal imageUrl="/images/2025/popup.jpg" targetUrl="/2025" />
    </div>
  );
};

export default ArchiveWrapper;
